import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BookingService } from '@markant-platform/cartridge/data-access';
import { catchError, firstValueFrom, of } from 'rxjs';

@Component({
  selector: 'markant-platform-cancel-process',
  templateUrl: './cancel-process.component.html',
  styleUrls: ['./cancel-process.component.scss'],
})
export class CancelProcessComponent {
  @Input() bookingId?: string;
  @Output() closed = new EventEmitter<void>();

  constructor(private readonly bookingService: BookingService) {}

  async sendCancellationRequest(): Promise<void> {
    if (!this.bookingId) {
      return;
    }

    await firstValueFrom(
      this.bookingService.requestCancellation(this.bookingId).pipe(
        catchError(() => {
          return of([]);
        })
      )
    );
  }
}
